// © Microsoft Corporation. All rights reserved.

/**
 * All the unique metadata type values returned from OneService
 * across various different data types except DenseList and BackFillContent.
 */
export enum OneServiceMetadataType {

    // individual content types
    Article = "article",
    Slideshow = "slideshow",
    Video = "video",
    Spotlight = "content360",

    // infopane
    Infopane = "infopane",

    // tabbed infopane
    TabbedInfopane = "tabbedInfopane",

    // complex content types
    HalfPane = "HalfPane",
    HeadToHead = "HeadToHead",
    Mosaic = "Mosaic",
    Triptych = "Triptych",

    // tab content type
    TabbedInfopaneTab = "tabbedInfopaneTab",

    // external content
    WebContent = "webcontent",
    ExternalLink = "link",

    // dense list card
    DenseList = "DenseList",

    // content to pass to the container experience
    BackFillContent = "BackfillContent",

    // My Brief River Card aka Top Picks
    MyBriefRiverCard = "toppicks",

    // Native Ad card type
    NativeAd = "nativead",
    CmsAd = "cmsad",

    // Shopping card and carousel types
    ShoppingCard = "ShoppingCard",
    ShoppingCarousel = "ShoppingCarousel",
    ComicsCarousel = "ComicsCarousel",
    EditorsPickCarousel = "EditorsPickCarousel",
    SelectCarousel = "SelectCarousel",
    WebNewsCarousel = "WebNewsCarousel",
    DailyFixGamesCarousel = "DailyFixGamesCarousel",
    NewsSegmentCarousel = "NewsSegmentCarousel",
    SubscriptionCarousel = "SubscriptionCarousel", // aka publisher carousel

    // Top Stories/Headlines card
    TopStories = "topStories",

    // Industry news card
    WorkHeadlines = "workNews",

    // TrendingNow&RecoSearch card
    Trending = "trendingnow",

    // Local news card
    LocalNews = "XfeedUpsell",
    LocalNewsFeed = "LocalNewsFeed",

    // 1U Trending Now
    TrendingInTenMinutes = "trendingInTenMinutes",

    // Horoscope Bing Answer card
    Horoscope = "Horoscope",

    // Elections Bing Answer card
    Elections = "GenericElection",

    // Recommended Search Carousel Card
    RecommendedSearchCarousel = "RecommendedSearch",

    // OnThisDay Bing Answer card
    OnThisDay = "OnThisDay",

    // Lottery card
    Lottery = "Lottery",

    // Partner Upsell
    PartnerUpsell = "PartnerUpsell",

    // Qna card
    Qna = "qnacard",

    // Recipes card
    Recipes = "recipecard",

    // Travel card
    TravelDestinationCard = "TravelDestinationCard",
    TravelDestinationCarouselCard = "TravelDestinationCarouselCard",
    TravelInspirationCard = "TravelInspirationCard",

    // Bing Health card
    BingHealthCovid19StatsCard = "Covid19Stats",

    // Placeholder card
    PlaceholderCard = "placeholder",

    // Windows card types
    BingVideo = "BingVideo",
    BingVideoCarousel = "BingVideoCarousel",
    EsportsHighlight = "esportsHighlight",
    EsportsLiveStream = "esportsLiveStream",
    EsportsMatch = "esportsMatch",
    EsportsTournament = "esportsTournament",
    WeatherSummary = "WeatherSummary",
    WeatherSummary_spotlight = "WeatherSummary_spotlight",
    StockQuote = "StockQuote",
    StockQuote_spotlight = "StockQuote_spotlight",
    MoneyInfo = "MoneyInfo",
    SportsMatch = "SportsMatch",
    SportsOlympics = "SportsOlympics",
    TrafficDelays = "TrafficDelays",
    ShoppingMerchantCategoryDeals = "ShoppingMerchantCategoryDeals",
    Group = "group",
    Upsell = "FreUpsell",
    Dense = "densetab",

    // Enterprise card types
    IndustryNewsCard = "IndustryNewsCard",
    RecommendedCardFeed = "RecommendedCardFeed",

    // Segments data stores are migrated to xfeedupsells as TopicFeed type
    TopicFeed = "TopicFeed"
}

/**
 * Returns the type to use in content of telemetry contract based content preview item type
 * @param type - content preview type
 * @returns type to use in content of telemetry contract
 */
export function getTelemetryTypeFromPreviewItemType(previewItemType: string): number {
    switch (previewItemType) {
        case "ArticlePreview":
            return 13;
        case "SlideshowPreview":
            return 14;
        case "VideoPreview":
            return 15;
        default:
            return null;
    }
}
